export enum LicensedEnum {
  UNKNOWN = "UNKNOWN",
  LICENSED = "LICENSED",
  UNLICENSED = "UNLICENSED"
}

export enum StatusEnum {
  IDLE = "IDLE",
  NO_DIAGNOSTIC = "NO_DIAGNOSTIC",
  START_DIAGNOSTIC = "START_DIAGNOSTIC",
  DIAGNOSTIC = "DIAGNOSTIC"
}

export interface ISubAssessment {
  takeID: string;
  name: string;
  order: number;
  pathID: number;
  version: number;
  status: string;
  score: number | null;
  assignmentID: string;
  parentAssignmentId?: string;
  subject?: string;
}

export interface IAssessment {
  id: number | string;
  title: string;
  state: string;
  startDate: string;
  endDate: string;
  subject: string;
  assessmentType: string;
  icon?: string;
  progress?: number;
  assessments?: ISubAssessment[];
  disabled?: boolean;
  testNumber?: number;
  dueDate?: string;
  isRetake?: boolean;
}

export const sessionStorageKeys = {
  diagnosticSubject: "ipa-diagnostic",
  diagnosticTitle: "ipa-diagnostic-title",
  returnUrl: "ipa-returnUrl",
  referrer: "ipa-referrer",
  multiDiagnostic: "ipa-multi-diagnostic",
  oneTimeToken: "ipa-ott"
};
